import { useCallback, useEffect, useState } from 'react'

import {
  BuyTourTicketApi,
  TourAppealDetails,
} from 'shared/api/tours/buy-ticket'

export const useAppealDetailsForMyOrders = (appealId: string | undefined) => {
  const [appealDetails, setAppealDetails] = useState<TourAppealDetails | null>(
    null,
  )
  const [isLoading, setIsLoading] = useState(false)

  const fetchAppealDetails = useCallback(async (id: string) => {
    setIsLoading(true)
    try {
      const {
        data: { data },
      } = await BuyTourTicketApi.getTourAppeal(id)

      if (data) setAppealDetails(data)
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    if (appealId) void fetchAppealDetails(appealId)
  }, [appealId, fetchAppealDetails])

  return { appealDetails, isLoading }
}
